import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { recentActivitiesQuery } from '@atlassian/search-client';
import { mapRecentActivitiesToSearchResult } from './recent-activities-mapper';
export var INCLUDED_PRODUCTS = ['confluence', 'jira', 'townsquare', 'graph'];
export var INCLUDED_OBJECT_TYPES = ['page', 'blogpost', 'whiteboard', 'issue', 'project', 'goal', 'content', 'document'];
export var fetchRecentActivities = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(cloudId, searchSessionId) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return recentActivitiesQuery({
            variables: {
              filteredProducts: INCLUDED_PRODUCTS,
              filteredObjectTypes: INCLUDED_OBJECT_TYPES,
              filteredRootContainerIds: ["ari:cloud:platform::site/".concat(cloudId), "ari:cloud:townsquare::site/".concat(cloudId)],
              itemsLimit: 200
            }
          }).then(function (response) {
            var _response$data;
            var edges = ((_response$data = response.data) === null || _response$data === void 0 || (_response$data = _response$data.activity) === null || _response$data === void 0 || (_response$data = _response$data.myActivity) === null || _response$data === void 0 || (_response$data = _response$data.all) === null || _response$data === void 0 ? void 0 : _response$data.edges) || [];
            try {
              return edges.map(function (edge) {
                return mapRecentActivitiesToSearchResult(edge, searchSessionId || '');
              });
            } catch (error) {
              return [];
            }
          }).catch(function (error) {
            throw error;
          });
        case 2:
          return _context.abrupt("return", _context.sent);
        case 3:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function fetchRecentActivities(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();